import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Gallery from '../components/Gallery';
import PAST_EVENTS from '../data/pastEvents';

const GalleryPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get initial tab from URL hash, or default to first event
  const getInitialTab = () => {
    const hash = location.hash.replace('#', '');
    return PAST_EVENTS.find(e => e.id === hash)?.id || PAST_EVENTS[0].id;
  };

  const [activeId, setActiveId] = useState(getInitialTab());

  // Update URL hash when tab changes
  const handleTabSelect = (eventKey: string | null) => {
    const newId = eventKey || PAST_EVENTS[0].id;
    setActiveId(newId);
    navigate(`#${newId}`, { replace: true });
  };

  // Update active tab when URL hash changes (e.g., browser back/forward)
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && PAST_EVENTS.find(e => e.id === hash)) {
      setActiveId(hash);
    }
  }, [location.hash]);

  const activeEvent = PAST_EVENTS.find(e => e.id === activeId) || PAST_EVENTS[0];

  return (
    <div className="container my-5">
      <h1 className="text-center">Gallery</h1>
      <p className="text-center">Explore our collection of images from past events.</p>

      <Nav variant="tabs" activeKey={activeId} onSelect={handleTabSelect} className="justify-content-center mb-4">
        {PAST_EVENTS.map(ev => (
          <Nav.Item key={ev.id}>
            <Nav.Link eventKey={ev.id}>{ev.title}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <Gallery images={activeEvent.images} title={activeEvent.title} />
    </div>
  );
};

export default GalleryPage;